
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SuspendedSubscriptionAlertProps {
  onRetry?: () => void;
  retryCount?: number;
}

export const SuspendedSubscriptionAlert = ({ 
  onRetry, 
  retryCount 
}: SuspendedSubscriptionAlertProps) => {
  return (
    <Alert variant="destructive" className="mb-8 max-w-3xl mx-auto">
      <InfoIcon className="h-4 w-4" />
      <AlertTitle>Subscription Suspended</AlertTitle>
      <AlertDescription>
        <p className="mb-2">
          Your subscription is currently suspended due to payment issues. Please update your payment method to resume your subscription.
        </p>
        {onRetry && (
          <Button 
            onClick={onRetry} 
            size="sm" 
            variant="outline"
            className="mt-2"
          >
            Retry Payment
            {retryCount !== undefined && retryCount > 0 && ` (${retryCount})`}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
